import { WEB_APP_HOST } from 'env';

const QR_PATH = '/qr/';

/** Returns the raw pathname prefix used by device QR links. */
export function getDeviceQrPathPrefix() {
  const base = new URL(WEB_APP_HOST);
  return `${base.pathname.replace(/\/$/, '')}${QR_PATH}`;
}

/** Decodes and validates one raw URL path segment as a QR ID. */
export function parseDeviceQrPathname(pathname: string) {
  const prefix = getDeviceQrPathPrefix();

  if (!pathname.startsWith(prefix)) {
    return null;
  }

  let rawQrId = pathname.slice(prefix.length);
  if (rawQrId.endsWith('/')) {
    rawQrId = rawQrId.slice(0, -1);
  }

  if (!rawQrId || rawQrId.includes('/') || /%(?![\dA-Fa-f]{2})/.test(rawQrId)) {
    return null;
  }

  try {
    const qrId = decodeURIComponent(rawQrId);
    const length = Array.from(qrId).length;

    if (!length || length > 255 || qrId.includes('\0')) {
      return null;
    }

    return qrId;
  } catch {
    return null;
  }
}

/** Parses the supported mobile-scanner URL variants into an exact QR ID. */
export function parseDeviceQrUrl(scannedValue: string) {
  const value = scannedValue.trim();
  if (!value) {
    return null;
  }

  if (/^[a-z][a-z\d+.-]*:/i.test(value) && !/^https?:\/\//i.test(value)) {
    return null;
  }

  const candidate = value.startsWith('//') ? `http:${value}` : /^https?:\/\//i.test(value) ? value : `http://${value}`;

  try {
    const url = new URL(candidate);
    const configuredUrl = new URL(WEB_APP_HOST);

    if (url.username || url.password || url.hostname.toLowerCase() !== configuredUrl.hostname.toLowerCase()) {
      return null;
    }

    if (url.port !== configuredUrl.port) {
      return null;
    }

    return parseDeviceQrPathname(url.pathname);
  } catch {
    return null;
  }
}
